export default __webpack_public_path__ + "static/media/cas-logo.7ee5d41c.png";